function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["variant", "children", "accessoryIcon", "accessoryImageUrl", "accessoryImageAlt", "accessoryIconColor"];
function cov_dj3jk7c01() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/CardListItem.tsx";
  var hash = "41759c23a7d0fb4ab45fad19fc46b9594cb62343";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/CardListItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 39,
          column: 57
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "1": {
        start: {
          line: 48,
          column: 17
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "2": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 75,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 57
          },
          end: {
            line: 39,
            column: 58
          }
        },
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 47
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 63,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 59,
            column: 22
          }
        }, {
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 62,
            column: 16
          }
        }],
        line: 59
      },
      "1": {
        loc: {
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 70,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 64,
            column: 26
          }
        }, {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 69,
            column: 12
          }
        }],
        line: 64
      },
      "2": {
        loc: {
          start: {
            line: 68,
            column: 17
          },
          end: {
            line: 68,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 17
          },
          end: {
            line: 68,
            column: 34
          }
        }, {
          start: {
            line: 68,
            column: 38
          },
          end: {
            line: 68,
            column: 40
          }
        }],
        line: 68
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "41759c23a7d0fb4ab45fad19fc46b9594cb62343"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dj3jk7c01 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dj3jk7c01();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useMultiStyleConfig } from "../../system/utils/index.mjs";
import Box from "../Box/index.mjs";
import Flex from "../Flex/index.mjs";
import { Icon } from "../Icon/index.mjs";
import Image from "../Image/index.mjs";
import { ListItem } from "./ListItem.mjs";
/**
 * CardListItem should only be used as a child of a List component with
 * variant="card"
 */
cov_dj3jk7c01().s[0]++;
export var CardListItem = function CardListItem(_ref) {
  var _ref2;
  var variant = _ref.variant,
    children = _ref.children,
    accessoryIcon = _ref.accessoryIcon,
    accessoryImageUrl = _ref.accessoryImageUrl,
    accessoryImageAlt = _ref.accessoryImageAlt,
    accessoryIconColor = _ref.accessoryIconColor,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_dj3jk7c01().f[0]++;
  var styles = (cov_dj3jk7c01().s[1]++, useMultiStyleConfig('CardListItem', _objectSpread({
    variant: variant
  }, props)));
  cov_dj3jk7c01().s[2]++;
  return /*#__PURE__*/React.createElement(ListItem
  // __css has a lower priority than sx
  , _extends({
    __css: styles.listItem
  }, props), /*#__PURE__*/React.createElement(Flex, {
    __css: styles.content
  }, (cov_dj3jk7c01().b[0][0]++, accessoryIcon) && (cov_dj3jk7c01().b[0][1]++, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    __css: styles.accessoryIconContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    __css: styles.accessoryIcon,
    name: accessoryIcon,
    color: accessoryIconColor
  }))), (cov_dj3jk7c01().b[1][0]++, accessoryImageUrl) && (cov_dj3jk7c01().b[1][1]++, /*#__PURE__*/React.createElement(Image, {
    __css: styles.accessoryImage,
    src: accessoryImageUrl,
    alt: (_ref2 = (cov_dj3jk7c01().b[2][0]++, accessoryImageAlt)) !== null && _ref2 !== void 0 ? _ref2 : (cov_dj3jk7c01().b[2][1]++, '')
  })), children), /*#__PURE__*/React.createElement(Icon, {
    __css: styles.chevron,
    name: "chevron-right",
    size: 16,
    "aria-hidden": true
  }));
};